import {Rule} from "./rule";

export class Contact {
  id: number;
  msisdn: string;
  title: string;
  rules: Array<Rule>;

  selected: boolean;

  constructor(id?: number, title?: string, msisdn?: string, rules?: Array<Rule>) {
    this.id = id;
    this.title = title;
    this.msisdn = msisdn;
    this.rules = rules;
  }
}
